document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.ProjectStore === 'undefined') return;

    const container = document.getElementById('pf-dashboard-container');
    if (!container) return;

    const incomplete = window.ProjectStore.getIncomplete();

    if (incomplete.length === 0) {
        renderEmptyState(container);
    } else {
        renderCards(incomplete, container);
    }

    function getResizedUrl(url, width) {
        if (!url) return '';
        if (url.includes('cdn.shopify.com')) {
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}width=${width}`;
        }
        return url; // Return original for Firebase or other sources
    }

    function renderEmptyState(container) {
        container.innerHTML = `
            <div class="pf-dashboard-empty">
                <h2>No masterpieces in progress</h2>
                <p>Start your custom portrait journey today.</p>
                <a href="/collections/portraits" class="pf-dashboard-btn">Start your Portrait</a>
            </div>
        `;
    }

    function renderCards(projects, container) {
        let html = '<div class="pf-dashboard-grid">';

        projects.forEach(p => {
            const percent = Math.floor((p.step_completed / p.step_total) * 100) || 5;
            const updated = new Date(p.updated_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
            const thumbUrl = (p.assets && p.assets.length > 0) ? p.assets[0].url : p.product_thumbnail_url;

            // Optimization: Small version for blur, medium for main thumbnail
            const blurUrl = getResizedUrl(thumbUrl, 50);
            const displayUrl = getResizedUrl(thumbUrl, 400);

            const thumb = thumbUrl
                ? `<div class="pf-card-media-wrapper">
                     <img src="${blurUrl}" class="pf-card-blur-bg" aria-hidden="true">
                     <img src="${displayUrl}" alt="${p.product_title}" class="pf-card-img-contain" loading="lazy">
                   </div>`
                : `<div class="pf-card-img-placeholder">🎨</div>`;

            html += `
                <div class="pf-dashboard-card" id="project-${p.project_id}">
                    <div class="pf-card-media">
                        ${thumb}
                    </div>
                    <div class="pf-card-info">
                        <h3>${p.product_title}</h3>
                        <div class="pf-card-progress-bar"><div class="pf-card-progress-fill" style="width:${percent}%"></div></div>
                        <div class="pf-card-meta">
                            <span>Last updated: ${updated}</span>
                            <span>${percent}% Complete</span>
                        </div>
                        <div class="pf-card-actions">
                            <a href="/products/${p.product_handle}?resume=1&project_id=${p.project_id}" class="pf-dashboard-btn-resume">Continue</a>
                            <button type="button" class="pf-dashboard-btn-discard" data-id="${p.project_id}">Discard</button>
                        </div>
                    </div>
                </div>
            `;
        });

        html += '</div>';
        container.innerHTML = html;

        document.querySelectorAll('.pf-dashboard-btn-discard').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const id = e.target.getAttribute('data-id');
                if (confirm('Are you sure you want to discard this in-progress painting?')) {
                    window.ProjectStore.archive(id);
                    const updatedProjects = window.ProjectStore.getIncomplete();
                    if (updatedProjects.length === 0) {
                        renderEmptyState(container);
                    } else {
                        document.getElementById(`project-${id}`).remove();
                    }
                    const event = new Event('DOMContentLoaded');
                    document.dispatchEvent(event); // Re-trigger CTA update
                }
            });
        });
    }
});
